import React from 'react';
import './Footer.css';
import { useTranslation } from '../../i18n/TranslationContext';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <h3>Vaudreuil Multiservices Inc.</h3>
              <p>{t.footer.about}</p>
              <div className="footer-social">
                <a href="https://www.facebook.com/vaudreuilmultiservicesinc/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              </div>
            </div>
            
            <div className="footer-links">
              <h4>{t.footer.quickLinks}</h4>
              <ul>
                <li><a href="#accueil">{t.header.home}</a></li>
                <li><a href="#about">{t.header.about}</a></li>
                <li><a href="#services">{t.header.services}</a></li>
                <li><a href="#gallery">{t.gallery.title}</a></li>
                <li><a href="#testimonials">{t.testimonials.title}</a></li>
                <li><a href="#contact">{t.contact.title}</a></li>
              </ul>
            </div>
            
            <div className="footer-services">
              <h4>{t.footer.ourServices}</h4>
              <ul>
                <li><a href="#services">{t.services.items.landscaping.title}</a></li>
                <li><a href="#services">{t.services.items.excavation.title}</a></li>
                <li><a href="#services">{t.services.items.leveling.title}</a></li>
                <li><a href="#services">{t.services.items.snowRemoval.title}</a></li>
                <li><a href="#services">{t.services.items.drainage.title}</a></li>
                <li><a href="#services">{t.services.items.poolExcavation?.title || 'Excavation pour piscine'}</a></li>
              </ul>
            </div>
            
            <div className="footer-contact">
              <h4>{t.footer.contactUs}</h4>
              <ul>
                <li><i className="fas fa-map-marker-alt"></i> {t.contact.info.address.value}</li>
                <li><i className="fas fa-phone"></i> <a href="tel:4189079922">{t.contact.info.phone.value}</a></li>
                <li><i className="fas fa-envelope"></i> <a href="mailto:vaudreuilmultiservices@gmail.com">{t.contact.info.email.value}</a></li>
                <li><i className="fas fa-clock"></i> {t.contact.info.hours.weekdays}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Vaudreuil Multiservices Inc. {t.footer.copyright}</p>
            <div className="footer-legal">
              <a href="#">{t.footer.privacy}</a>
              <span>|</span>
              <a href="#">{t.footer.terms}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;